import apiInstance from '../../apiInstance';
import Stripe from '../../../utility/stripe';

export async function addonCheckout({ siteId, addonName, userEmail }) {

    const payload = {
        websiteData: { id: siteId }
    };

    payload.addonName = addonName;
    payload.customerEmail = userEmail;
    
    const response = await apiInstance.post(
        '/dashboard/checkout-session/',
        payload
    );

    if(response.data.subscriptionExists) {
        const paymentUrl = response.data.paymentUrl;
        if (paymentUrl) {
            window.location.href = paymentUrl;
        }
    } else {
        const stripe = await Stripe();
        const session = response.data;
        const { error } = await stripe.redirectToCheckout({
            sessionId: session.id,
        });

        if (error) {
            throw new Error(error.message);
        }
    }

    return true;
}
